/*

~initialize~
<TableForm
  scroll = {true|false}
  columnWidth = {numberArray}
  selectable={true|false}
  tabledata={tabledata}
/>

tabledata = {
  header : {
    main : [
      { data : "#" }, { data : "상태" }, { data : "금액" }, { data : "식대 그룹" }, { data : "식대 정책" },
      { data : "신청 시각" }, { data : "지급/차감 시각" }, { data : "총인원" }, { data : "성공" }, { data : "실패" },
      { data : "신청자" }, { data : "사유" }
    ]
  },
  body : {
    message : "식대 지급/차감 내역이 존재하지 않습니다.",
    main : null
  },
  footer : {}
}
~initialize~

let tabledata = {
  header : {
    main : [
      {
        data :,
        colSpan : number,
        textAlign : number
      }
    ],
    sub : [
      {
        data :,
        colSpan : number,
        textAlign : number
      }
    ]
  },
  body   : {
    maxHeight : number,
    message : string,     // when main not existed
    main : [
      {
        clickFunc : function,
        clickData : whatever you can return,
        row : [
          {
            data : ,
            btnFunc : function,
            btnData : whatever you can return,
            fontColor : #color,
            fontWeight : "bold" / default:inherit
            textAlign : "left"|"right" / default(center)
          }, {

          }
        ]
      }, {

      }
    ]
  },
  footer : {
    page : number,
    pagerow : number,
    pageblock : number,
    totalcount : number,
    pageClick : function
  }
};

*/

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Table, Button, Popup } from 'semantic-ui-react';

import { Pagination } from 'components/Commons';

import cm from 'helpers/commons';

class TableForm extends Component {
  constructor(props) {
    super(props);
  }

  makeHeader = (headerData, widths, height) => {
    let sub;
    let main;

    if (headerData.main) {
      main = this.headerRow(headerData.main, widths, height);
    }

    if (headerData.sub) {
      sub = this.headerRow(headerData.sub, widths, height, 'sub');
    }
    // onClick 은 행 클릭용(onClick(e, idx)) — 헤더로 넘어가면 index 없이 호출된다
    const { columnWidth, togglestatus, onClick, ...other } = this.props;
    return (
      <Table.Header {...other}>
        {main}
        {sub}
      </Table.Header>
    );
  };

  headerRow = (item, widths, height, type = 'main') => {
    let cols;

    if (widths) {
      let start_idx = 0;
      cols = item.map((data, idx) => {
        let wid;
        if (data.colSpan) {
          wid = widths.slice(start_idx, start_idx + data.colSpan).reduce((prevVal, curr) => {
            return prevVal + curr;
          });

          start_idx += data.colSpan;
        } else {
          wid = widths.slice(start_idx, start_idx + 1);
          start_idx += 1;
        }

        return this.headerCol(idx, data, wid, height);
      });
    } else {
      cols = item.map((data, idx) => {
        return this.headerCol(idx, data, null, height);
      });
    }

    return (
      <Table.Row key={type} className={type}>
        {cols}
      </Table.Row>
    );
  };

  headerCol = (idx, item, width, height) => {
    const { data, textAlign, colSpan, isTooltip, icon, content, tooltipProps } = item;
    const title = data || '';
    const align = textAlign || 'center';
    const span = colSpan || 1;

    return (
      <Table.HeaderCell
        key={`header_${idx}`}
        textAlign={align}
        colSpan={span}
        style={{ width: `${width}px`, height: `${height}px` }}
      >
        {title}
        {isTooltip ? (
          // tooltipProps 는 헤더 item 이 준 경우에만 Popup 옵션(hoverable 등)을 덧붙인다. 없으면 기존과 동일하게 렌더된다
          <Popup
            content={content}
            inverted
            trigger={<span style={{ paddingLeft: '3px' }}>{icon}</span>}
            {...tooltipProps}
          />
        ) : null}
      </Table.HeaderCell>
    );
  };

  makeBody = (bodyData, widths, colLength, columnWidth) => {
    const { maxHeight } = bodyData;

    let main;
    if (bodyData.main) {
      main = bodyData.main.map((item, idx) => {
        return this.bodyRow(idx, item, columnWidth);
      });
    } else {
      let message = '요청한 자료의 목록이 존재하지 않습니다.';
      if (bodyData.message) {
        message = bodyData.message;
      }

      let width = 'auto';
      if (columnWidth && columnWidth.length > 0) {
        width = columnWidth.reduce((total, num) => {
          return total + num;
        });
      }

      main = (
        <Table.Row>
          <Table.Cell colSpan={colLength} textAlign="center" style={{ width }}>
            {message}
            {/* <Popup content="test" trigger={<span>{message}</span>}/> */}
          </Table.Cell>
        </Table.Row>
      );
    }

    return <Table.Body style={{ maxHeight: `${maxHeight}px` }}>{main}</Table.Body>;
  };

  bodyRow = (idx, item, widths) => {
    let cols;
    let rowClass = null;
    const border = item.row.map((col) => {
      if (col.border) {
        rowClass = 'border';
      }
      return rowClass;
    });

    const { togglestatus, onClick } = this.props;
    if (widths) {
      let start_idx = 0;

      cols = item.row.map((col, colIdx) => {
        let wid;
        if (col.colSpan) {
          wid = widths.slice(start_idx, start_idx + col.colSpan).reduce((prevVal, curr) => {
            return prevVal + curr;
          });

          start_idx += col.colSpan;
        } else {
          wid = widths.slice(colIdx, colIdx + 1);
          start_idx += 1;
        }

        return this.bodyCol(colIdx, col, wid, col.btnProps);
      });
    } else {
      if (!item.row) return;
      cols = item.row.map((col, colIdx) => {
        return this.bodyCol(colIdx, col, col.width, col.btnProps);
      });
      if (togglestatus) {
        return (
          <Table.Row key={`row_${idx}`} className={rowClass} onClick={(e) => onClick(e, idx)}>
            {cols}
          </Table.Row>
        );
      }
    }

    if (item.clickFunc) {
      if (typeof item.clickFunc === 'string') {
        return (
          <Table.Row key={`row_${idx}`} className={rowClass} onClick={item.clickComponent}>
            {cols}
          </Table.Row>
        );
      }
      return (
        <Table.Row key={`row_${idx}`} className={rowClass} onClick={(e) => item.clickFunc(item.clickData)}>
          {cols}
        </Table.Row>
      );
    }
    return (
      <Table.Row className={rowClass} key={`row_${idx}`}>
        {cols}
      </Table.Row>
    );
  };

  bodyCol = (idx, item, width, btnProps) => {
    const align = item.textAlign ? item.textAlign : 'center';

    let tdData = '';
    if (item.btnFunc && !cm.valueCheck(item.btnFunc)) {
      tdData = (
        <Button color="black" inverted onClick={(e) => item.btnFunc(item.btnData)} {...btnProps}>
          {item.data}
        </Button>
      );
    } else {
      tdData = item.data;
    }

    return (
      <Table.Cell
        key={`col_${idx}`}
        textAlign={align}
        colSpan={item.colSpan}
        style={{
          width: `${width}px`,
          color: item.fontColor,
          backgroundImage: item.backgroundImage,
          fontWeight: item.fontWeight,
          textDecoration: item.textDecoration,
          backgroundSize: item.backgroundSize,
          whiteSpace: item.whiteSpace ? item.whiteSpace : null,
          background: item.background
        }}
      >
        {/* {tdData} */}
        {item.isTooltip ? <Popup content={tdData} inverted trigger={<span>{tdData}</span>} /> : tdData}
      </Table.Cell>
    );
  };

  makeFooter = (item, colLength, colWidth) => {
    const pagination = (
      <Pagination
        page={item.page}
        pageRow={item.pagerow}
        pageBlock={item.pageblock}
        totalCount={item.totalcount}
        pageClick={item.pageClick}
      />
    );
    let footerCell = (
      <Table.HeaderCell textAlign="center" colSpan={colLength}>
        {pagination}
      </Table.HeaderCell>
    );

    if (colWidth) {
      const wid = colWidth.reduce((prevVal, curr) => {
        return prevVal + curr;
      });

      footerCell = (
        <Table.HeaderCell textAlign="center" colSpan={colLength} style={{ width: `${wid}px` }}>
          {pagination}
        </Table.HeaderCell>
      );
    }

    return (
      <Table.Footer>
        <Table.Row>{footerCell}</Table.Row>
      </Table.Footer>
    );
  };

  render() {
    const { scroll, selectable, columnWidth, tbcommon } = this.props;
    const { header, body, footer } = this.props.tabledata;
    const colLength = header.main ? header.main.length : 0;
    // colWidth = columnWidth ? columnWidth.reduce((total, val, idx) => { return total + val; }) : "";

    const classes = classNames({
      'tb-common': !tbcommon,
      scroll: !!scroll,
      'non-scroll': !!(!scroll && columnWidth),
      selectable: !!selectable
    });
    const tableHeader = header ? this.makeHeader(header, columnWidth) : null;
    const tableBody = body ? (
      this.makeBody(body, columnWidth, colLength, columnWidth)
    ) : (
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={colLength} textAlign="center">
            요청한 자료의 목록이 존재하지 않습니다.
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    );
    const tableFooter = footer ? this.makeFooter(footer, colLength, columnWidth) : null;

    return (
      <Table className={classes}>
        {tableHeader}
        {tableBody}
        {tableFooter}
      </Table>
    );
  }
}

export default TableForm;
